import { Button, Typography } from '@mui/material'
import CardTAG from '../../CardTAG'
import PasswordInput from '../../PasswordInput'
import FormLayout from '../FormLayout'
import { IResetPasswordForm } from './types'

const ResetPasswordForm: React.FC<IResetPasswordForm> = ({
  register,
  passwordError = '',
  passwordRepeatError = '',
}) => {
  return (
    <CardTAG title='Create a new password'>
      <Typography variant='bodyRegular' align='left' sx={{ marginBottom: '2.8rem' }}>
        Your new password must be different from previously used passwords.
      </Typography>
      <FormLayout>
        <PasswordInput
          register={register}
          fieldName='password'
          label='New Password'
          error={passwordError}
        />
        <PasswordInput
          register={register}
          fieldName='password_repeat'
          label='Confirm New Password'
          error={passwordRepeatError}
        />
        <Button variant='submitFormButton' type='submit'>
          <Typography variant='bodyBold'>Reset Password</Typography>
        </Button>
      </FormLayout>
    </CardTAG>
  )
}

export default ResetPasswordForm
